var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"ma-0",attrs:{"color":_vm.badge.color,"text-color":_vm.badge.text,"small":_vm.small}},[_vm._v("\n  "+_vm._s(_vm.title ? _vm.title : _vm.$t(("badges." + (_vm.badge.label))))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2fee6dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Badge.vue
// module id = null
// module chunks = 